/**
 * The locale vocabulary, kept free of every import.
 *
 * `main.ts` resolves the language before Angular boots and must not pull the
 * framework into that path, so these constants live apart from `LocaleService`
 * (which injects HttpClient, AuthService and AuthStore). The service re-exports
 * them, so application code keeps importing from `locale-service`.
 */

/** The languages the application ships translations for. */
export type AppLocale = 'de' | 'en';

export const LOCALES: readonly AppLocale[] = ['de', 'en'];

/**
 * The source language: every `$localize` message is authored in German, so this
 * locale needs no translation file.
 */
export const DEFAULT_LOCALE: AppLocale = 'de';

/**
 * Written by the backend's `LocaleController` and deliberately left
 * unencrypted, so the choice is known before Angular boots.
 */
export const LOCALE_COOKIE_NAME = 'locale';

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && LOCALES.includes(value as AppLocale);
}
